'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'messages';
var width = 576;
var height = 512;
var aliases = ["comments-alt"];
var unicode = 'f4b6';
var svgPathData = 'M32 40l0 192c0 22.1 17.9 40 40 40l40 0c8.8 0 16 7.2 16 16l0 45.8 58.6-48.9c10.1-8.4 22.7-13 35.9-13l89.5 0c22.1 0 40-17.9 40-40l0-192c0-22.1-17.9-40-40-40L72 0C49.9 0 32 17.9 32 40zM72-32l240 0c39.8 0 72 32.2 72 72l0 192c0 39.8-32.2 72-72 72l-89.5 0c-5.6 0-11.1 2-15.4 5.6l-84.9 70.7c-4.8 4-11.4 4.8-17 2.2S96 374.2 96 368l0-64-24 0c-39.8 0-72-32.2-72-72L0 40C0 .2 32.2-32 72-32zM224 358l0 34c0 22.1 17.9 40 40 40l89.5 0c13.1 0 25.8 4.6 35.9 13l58.6 48.9 0-45.8c0-8.8 7.2-16 16-16l40 0c22.1 0 40-17.9 40-40l0-192c0-22.1-17.9-40-40-40l-72 0 0-32 72 0c39.8 0 72 32.2 72 72l0 192c0 39.8-32.2 72-72 72l-24 0 0 64c0 6.2-3.6 11.9-9.2 14.5s-12.3 1.8-17-2.2l-84.9-70.7c-4.3-3.6-9.8-5.6-15.4-5.6L264 464c-39.8 0-72-32.2-72-72l0-7.4 32-26.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMessages = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;